import { render, staticRenderFns } from "./royalProperty.vue?vue&type=template&id=a60daaa6&scoped=true"
import script from "./royalProperty.vue?vue&type=script&lang=js"
export * from "./royalProperty.vue?vue&type=script&lang=js"
import style0 from "./royalProperty.vue?vue&type=style&index=0&id=a60daaa6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60daaa6",
  null
  
)

export default component.exports